/**
 * @author  :  zgg
 * @created :  2019/06/26
 * @version :  v1.0
 * @desc    :  辅导员查看学生学习进度和评分js界面
 */
export default {
    data() {
        return {
            outline: '', //项目大纲
            answer: '', //答案传递变量
            comment: [], //讨论发表传递变量
            user: '', //用户信息
            classId: '', //班级id
            userId: '', //用户id
            progress: '', //项目进度
            purchasedId: '', //订单项id
            proportion: '', //评分占比
            input: [], //输入框
            regulation: [], //保存规则为1的索引
            totalPoints: 0, //总分
            productId: '', //产品id
            instructor_id: '', // 辅导员id
            instructorComment: [], // 辅导员主题讨论的回复
            score: 0, // 学员的分数
            outline2: '' // 项目大纲，这个项目大纲用来显示数据
        }
    },
    methods: {
        //----------------------------------------------------逻辑区-----------------------------------------------//
        /**
         * @author  :  zgg
         * @created :  2019/06/30
         * @version :  v1.0
         * @desc    :  初始化
         */
        async init() {
            this.getUserId()
            await this.getPurchased()
            await this.getjindu()
            await this.getCodePoints()
            this.circulation()
            //this.calculateScore()
        },

        /**
         * @author  :  zgg
         * @created :  2019/06/28
         * @version :  v1.0
         * @desc    :  提交分数
         */
        async noSubmitScores(input, i, j, y, z, instructorComment) {

            if (input > 100 || input < 0) {
                this.$message({
                    message: '请输入0~100',
                    type: 'error'
                });
            } else {
                await this.postCounselorScore(input, i, j, y, z, instructorComment)
                this.CounselorRating()
            }

            //this.calculateScore()
        },
        //-----------------------------------------------end：逻辑区---------------------------------------------//

        //----------------------------------------------------方法区------------------------------------------------//
        /**
         * @author  :  zgg
         * @created :  2019/06/26
         * @version :  v1.0
         * @desc    :  获取学生订单项id
         */
        getPurchased() {
            return this.$post('class_users/search', {
                token: this.$store.state.instructor,
                offset: 0,
                length: 500,
                user_id: this.userId,
                class_id: this.classId,
            }).then(res => {
                // // console.log('获取学生信息',res.data.result.data[0])
                this.purchasedId = res.data.result.data[0].purchased_id
                this.productId = res.data.result.data[0].product_id
                this.score = res.data.result.data[0].score
            })
        },

        /**
         * @author  :  zgg
         * @created :  2019/06/26
         * @version :  v1.0
         * @desc    :  获取项目大纲
         */
        getjindu() {
            return this.$post('purchased/get_rate_by_userid', {
                token: this.$store.state.instructor,
                offset: 0,
                length: 500,
                id: this.purchasedId
            }).then(res => {
                // // console.log('获取项目大纲',res)
                let data = res.data.result.data[0]
                this.progress = +(data.progress * 100).toFixed(0) //保存总进度
                this.outline = JSON.parse(data.rate) //有进度获取进度数据
                this.outline2 = JSON.parse(data.rate)
                console.log('this.outline2 ', this.outline2)
                // console.log("this.outline ", this.outline);
            })
        },

        /**
         * @author  :  zgg
         * @created :  2019/06/26
         * @version :  v1.0
         * @desc    :  获取用户id
         */
        getUserId() {
            return this.$post('class_users/search', {
                token: this.$store.state.instructor,
                offset: 0,
                length: 500,
                class_id: this.classId,
                user_id: this.userId
            }).then((res) => {
                this.user = res.data.result.data[0]
                //页面标题
                document.title = this.user.name;
                // // console.log('用户信息1',res)
            })
        },

        /**
         * @author  :  zgg
         * @created :  2019/06/28
         * @version :  v1.0
         * @desc    :  获取评分规则
         */
        getCodePoints() {
            return this.$post('proportion/get', {
                token: this.$store.state.instructor,
                product_id: this.productId,
                // shop_id: this.$store.state.store.id
            }).then(res => {
                // console.log('res', res)
                //// console.log('评分规则',res.data.result.resources)
                if (res.data.result == null) {
                    // this.$message({
                    //     message: '暂未配置评分规则请前往后台配置！',
                    //     type: 'error'
                    // });
                    alert('暂未配置评分规则请前往后台配置！')
                    return
                }
                this.proportion = JSON.parse(res.data.result.resources)
                // // console.log('评分规则',this.proportion)
            })
        },

        /**
         * @author  :  zgg
         * @created :  2019/06/28
         * @version :  v1.0
         * @desc    :  保存分数
         */
        postSaveScore() {
            if (this.totalPoints) {
                this.$post('purchased/sumbitResult', {
                    token: this.$store.state.instructor,
                    score: this.totalPoints,
                    id: this.purchasedId
                }).then(res => {
                    // 获取分数
                    this.getPurchased()
                })
            }
        },

        /**
         * @author  :  zgg
         * @created :  2019/06/26
         * @version :  v1.0
         * @desc    :  根据两位小数进度转换为*100，变成整数的进度，防止显示进度时不会报js浮点运算错误
         */
        calculateNum(num) {
            if (num) {
                return +(num * 100).toFixed(0)
            }
        },

        /**
         * @author  :  zgg
         * @created :  2019/06/26
         * @version :  v1.0
         * @desc    :  获取答案 : 根据类型获取对映资源答案
         */
        getPrivate(resourceId, i, j, y, z) {
            // console.log('resourceId = ' + resourceId + ' i = ' + i + ' j = ' + j + ' y = ' + y + ' z ' + z)
            this.$post('private/get_by_purchased_id', {
                token: this.$store.state.instructor,
                purchased_id: this.purchasedId,
                resource_id: resourceId
            }).then(res => {
                // console.log(res)
                // // console.log('获取提交内容',res)
                // res.data.result ? this.outline[i].task_activities[j].resources[y].items[z].answer = res.data.result.content : null
                res.data.result ? this.outline2[i].task_activities[j].resources[y].items[z].answer = res.data.result.content : null
                // 修改数组触发视图变化
                this.outline2.push({
                    message: 'Baz'
                })
                this.outline2.pop()
            })

        },

        /**
         * @author  :  zgg
         * @created :  2019/06/26
         * @version :  v1.0
         * @desc    :  获取主题讨论: 根据类型获取主题讨论:
         */
        getDiscussion(resourceId, i, j, y, z) {
            let DiscussionForum
            this.$post('discuss_theme/get_with_comment', {
                token: this.$store.state.instructor,
                resource_id: resourceId
            }).then(res => {
                DiscussionForum = res.data.result;
                this.$post('comment/get_comment_by_theme', {
                    token: this.$store.state.instructor,
                    discuss_theme_id: DiscussionForum.id,
                    user_id: this.userId,
                    product_id: this.productId,
                    offset: 0,
                    length: 999
                }).then(res => {
                    // console.log('获取主题讨论', res)
                    // this.outline[i].task_activities[j].resources[y].items[z].answer = res.data.result.data
                    this.outline2[i].task_activities[j].resources[y].items[z].answer = res.data.result.data
                    // 修改数组触发视图变化
                    this.outline2.push({
                        message: 'Baz'
                    })
                    this.outline2.pop()
                })
            })

        },

        // 获取研修日志内容
        getLog(resourceId, i, j, y, z) {
            // console.log('resourceId ', resourceId);
            // console.log('i ', i);
            // console.log('j ', j);
            // console.log('y ', y);
            // console.log('z ', z);
            let outline = this.outline;
            // console.log('outline ', outline);
            let taskId = outline[i].task_id;
            // console.log('taskId ', taskId);
            // console.log('productId ', this.productId);
            // console.log('userId ', this.userId);
            this.$post('user_training_log/getTrainingLogForInstructor', {
                token: this.$store.state.instructor,
                shop_id: 8,
                owner_id: this.userId,
                task_id: taskId,
                product_id: this.productId,
            }).then(res => {
                res.data.result ? this.outline2[i].task_activities[j].resources[y].items[z].answer = res.data.result.private : null;
                // 修改数组触发视图变化
                this.outline2.push({
                    message: 'Baz'
                });
                this.outline2.pop();
            });

        },

        /**
         * @author  :  zgg
         * @created :  2019/06/26
         * @version :  v1.0
         * @desc    :  遍历大纲插入数据
         */
        circulation() {
            for (let i = 0; i < this.outline.length; i++) {
                // this.outline[i].percentage = this.proportion[i].percentage
                for (let j = 0; j < this.outline[i].task_activities.length; j++) {
                    // this.outline[i].task_activities[j].percentage = this.proportion[i].task_activities[j].percentage
                    for (let y = 0; y < this.outline[i].task_activities[j].resources.length; y++) {
                        // this.outline[i].task_activities[j].resources[y].percentage = this.proportion[i].task_activities[j].resources[y].percentage
                        if (this.proportion[i].task_activities[j].resources[y].rule === 1) {
                            this.regulation.push({
                                i: i,
                                j: j,
                                y: y
                            })
                        }
                        for (let z = 0; z < this.outline[i].task_activities[j].resources[y].items.length; z++) {
                            // this.outline[i].task_activities[j].resources[y].items[z].percentage = this.proportion[i].task_activities[j].resources[y].items[z].percentage
                            // this.outline[i].task_activities[j].resources[y].items[z].rule = this.proportion[i].task_activities[j].resources[y].items[z].rule
                            let resourceId = this.outline[i].task_activities[j].resources[y].items[z].resources[0]
                            if (this.proportion[i].task_activities[j].resources[y].items[z].rule === 1) {
                                this.regulation.push({
                                    i: i,
                                    j: j,
                                    y: y
                                })
                            }

                            let aaa = this.outline[i].task_activities[j].resources[y].items[z]
                            // console.log(this.outline[i].task_activities[j].resources[y].items[z].name)
                            // console.log(this.outline[i].task_activities[j].resources[y].items[z].type)
                            let type = parseInt(this.outline[i].task_activities[j].resources[y].items[z].type)
                            switch (type) {
                                case 7: {
                                    this.getPrivate(resourceId, i, j, y, z)
                                    break;
                                }
                                case 6: {
                                    this.getDiscussion(resourceId, i, j, y, z)
                                    break;
                                }
                                case 8: {
                                    this.getLog(resourceId, i, j, y, z);
                                    break;
                                }

                                default:
                                    break;
                            }
                        }
                    }
                }
            }

            // if (parseInt(this.progress) < 100) {
            this.calculateScore()
            // }

            //   // console.log('	this.regulation',	this.regulation)
            // // console.log( 'fudaoyuanddddddddddd',this.CounselorRating())
        },
        /**
         * @author  :  zgg
         * @created :  2019/06/30
         * @version :  v1.0
         * @desc    :  将辅导员提交的分数插入json中并保存至服务器
         */
        postCounselorScore(input, i, j, y, z, instructorComment) {
            this.outline[i].task_activities[j].resources[y].items[z].grade = input
            this.outline[i].task_activities[j].resources[y].items[z].instructorComment = instructorComment

            this.outline2[i].task_activities[j].resources[y].items[z].grade = input
            this.outline2[i].task_activities[j].resources[y].items[z].instructorComment = instructorComment

            let json = JSON.stringify(this.outline)
            // console.log('提交的json是：', json)
            return this.$post('purchased/sumbitRate', {
                token: this.$store.state.instructor,
                id: this.purchasedId,
                rate: json
            }).then(res => {
                this.$message({
                    message: '分数提交成功！',
                    type: 'success'
                });
                // 修改数组触发视图变化
                this.outline.push({
                    message: 'Baz'
                })
                this.outline.pop()

                // 修改数组触发视图变化
                this.outline2.push({
                    message: 'Baz'
                })
                this.outline2.pop()

                // // console.log('提交成功！')
                // console.log(this.outline)
            })
        },

        /**
         * @author  :  zgg
         * @created :  2019/06/28
         * @version :  v1.0
         * @desc    :  判断辅导员是否完成评分 ：已完成（true）
         */
        CounselorRating() {
            // console.log('判断评分是否完成')
            // console.log(this.regulation)
            for (let h = 0; h < this.regulation.length; h++) {
                let {
                    i,
                    j,
                    y
                } = this.regulation[h]
                for (let z = 0; z < this.outline[i].task_activities[j].resources[y].items.length; z++) {
                    if (!this.outline[i].task_activities[j].resources[y].items[z].grade) {
                        return false
                    }
                }
            }
            // // console.log('总分：',this.calculateScore() )
            this.calculateScore()
            return true
        },

        /**
         * @author  :  zgg
         * @created :  2019/06/28
         * @version :  v1.0
         * @desc    :  计算分数并保存至服务器
         */
        calculateScore() {
            // console.log('计算分数')
            // console.log(this.outline)
            let points1 = 0
            for (let i = 0; i < this.outline.length; i++) {
                let points2 = 0
                let outline = this.outline[i]
                // // console.log('outline',outline)
                for (let j = 0; j < this.outline[i].task_activities.length; j++) {
                    let points3 = 0
                    let task_activitie = this.outline[i].task_activities[j]
                    for (let y = 0; y < this.outline[i].task_activities[j].resources.length; y++) {
                        let points4 = 0
                        let resource = this.outline[i].task_activities[j].resources[y]
                        for (let z = 0; z < this.outline[i].task_activities[j].resources[y].items.length; z++) {
                            let item = this.outline[i].task_activities[j].resources[y].items[z]
                            let state = item.state ? item.state : 0
                            state = parseInt(state)
                            let grade = item.grade ? item.grade : 0
                            grade = parseInt(grade)
                            let rule = item.rule
                            rule = parseInt(rule)
                            if (state === 2) {
                                if (rule === 1) {
                                    points4 += grade
                                } else {
                                    points4 += 100
                                }
                            }
                        }
                        points4 = points4 / resource.items.length
                        points3 += points4 * resource.percentage / 100
                    }
                    points2 += points3 * task_activitie.percentage / 100
                    // console.log('posints2 = ', points2)
                }
                points1 += points2 * outline.percentage / 100
            }
            // console.log(this.outline)
            this.totalPoints = points1.toFixed(0)
            // console.log(this.totalPoints)
            this.postSaveScore() //提交到服务器
            // 获取分数
            // this.getPurchased()
            return points1.toFixed(0)
        },

        // 辅导员评论
        review(data) {
            // console.log(data)
            let resource_id = data.resources[0]
            // 获取comment_id
            this.$post('resources/get_comment', {
                token: this.$store.state.id,
                id: resource_id,
                user_id: this.userId,
                offset: 0,
                length: 1
            }).then(res => {
                let comment_id = res.data.result.data[0].comment_id
                this.$post('instructor_comment/create', {
                    content: this.comment,
                    instructor_id: this.instructor_id,
                    to_comment_id: comment_id
                }).then(res => {
                    if (res.status === 200) {
                        this.$message({
                            type: 'success',
                            message: '评论成功'
                        })
                    }
                    this.comment = ''
                })
            })
        },

        // 获取百分比  data是每个活动的数据
        getPercentage(data) {
            // // console.log(data)
            // // console.log('出去循环l ')
            // 当前进度百分比
            let currProgress = 0
            // 总进度
            let allProgress = 0

            for (let i = 0; i < data.resources.length; i++) {

                for (let j = 0; j < data.resources[i].items.length; j++) {

                    let obj = data.resources[i].items[j]
                    if (!this.$isAbnormal(obj.progress)) {
                        currProgress = currProgress + obj.progress * 1
                    }
                    allProgress = allProgress + 1
                }
            }

            return ((currProgress / allProgress) * 100).toFixed(0) * 1
            // // 控制返回的是什么
            // let returnVideoFlag = false
            // let returnEBooks = false
            // let returnCoursework = false
            // let returnPortalTalk = false

            // // 当前视频观看百分比
            // let currVideoProgress = 0
            // // 有多少个视频，allVideoProgress就为几，currVideoProgress / allVideoProgress 就得到视频总进度
            // let allVideoProgress = 0

            // // 当前电子书阅读观看百分比
            // let currEBookProgress = 0
            // let allEBookProgress = 0

            // // 课程作业
            // let coursework = 0

            // // 主题讨论
            // let portalTalk = 0

            // for (let i = 0; i < data.length; i++) {

            //     // 当前是视频
            //     if (data[i].type == 0) {
            //         returnVideoFlag = true
            //         let num = Number.isNaN(data[i].progress * 1) ? 0 : data[i].progress * 1
            //         currVideoProgress = currVideoProgress + num
            //         allVideoProgress++
            //     }

            //     // 当前是电子书阅读
            //     if (data[i].type == 0 && data[i].currentTime == 1) {
            //         returnEBooks = true
            //         let num = Number.isNaN(data[i].progress * 1) ? 0 : data[i].progress * 1
            //         currEBookProgress = currEBookProgress + num
            //         allEBookProgress++
            //     }

            //     // 当前是课程作业
            //     if (data[i].type == 7) {
            //         returnCoursework = true

            //         // 如果课程作业有回答，则该课程作业进度为1
            //         if (!this.$isAbnormal(data[i].answer)) {
            //             coursework = 1
            //         } else {
            //             coursework = 0
            //         }
            //     }

            //     // 当前是主题讨论
            //     if (data[i].type == 6) {
            //         returnPortalTalk = true

            //         // 如果讨论区有回答，则该主题讨论的进度为1
            //         if (!this.$isAbnormal(data[i].answer) && data[i].answer.length > 0) {
            //             portalTalk = 1
            //         } else {
            //             portalTalk = 0
            //         }
            //     }
            // }
            // if (returnVideoFlag) {
            //     return ((currVideoProgress / allVideoProgress) * 100).toFixed(0) * 1
            // } else if (returnEBooks) {
            //     return ((currEBookProgress / allEBookProgress) * 100).toFixed(0) * 1
            // } else if (returnCoursework) {
            //     return coursework == 1 ? 1 * 100 : 0
            // } else if (returnPortalTalk) {
            //     return portalTalk == 1 ? 1 * 100 : 0
            // }
        },

        /**
         * 返回活动名称，课程作业和主题讨论返回具体的题目名称
         * @param activity
         */
        returnActivityName(activity) {
            let type = Number.parseInt(activity.resources[0].items[0].type);
            if (type === 6 || type === 7) {
                return activity.resources[0].items[0].name;
            }
            return activity.activitie_name;
        }

        //---------------------------------------------end：方法区-----------------------------------------------//


    },
    //--------------------------------------------end:methods--------------------------------------------//
    created() {
        if (this.$route.query.purchasedId && this.$route.query.userId && this.$route.query.classId) {
            this.purchasedId = this.$route.query.purchasedId
            this.userId = this.$route.query.userId
            this.classId = this.$route.query.classId
            this.product_id = this.$route.query.product_id
            this.instructor_id = this.$route.query.instructor_id
            this.init()
            //updata
        }


    },

    mounted() {

    },
}
